import React, { memo } from "react"
import SectionsTitle from "../../../Common/new/SectionsTitle"
import LinkButtonRed from "../../buttons/linkButtonRed/linkButtonRed"
import parse from "html-react-parser"
import * as style from "./style.module.css"

const HireDeveloper = props => {
  const {
    capHireShowSection,
    CustomClass,
    capHireTitle,
    capHireSubTitle,
    capHireBoxIcon,
    capHireBoxTitle,
    capHireBoxButtonLink,
    capHireBoxButtonText,
    capHireBoxContent,
    capIntroContent,
    capHireListOfTechnology,
  } = props

  return (
    <>
      {capHireShowSection === "yes" && (
        <section className={`${CustomClass}`}>
          <div className="container">
            <div>
              <SectionsTitle
                title={capHireTitle}
                SubTitle={capHireSubTitle}
                Content={capIntroContent}
                styleCss={{ display: "none" }}
              />
            </div>
            <div className={style.developer_card}>
              <div className={style.developer_card_title}>
                <i> {parse(`${capHireBoxIcon}`)}</i>
                <h3>{capHireBoxTitle}</h3>
              </div>
              <p>{capHireBoxContent}</p>
              <LinkButtonRed
                CustomBtnClass={style.btn_class}
                btnText={capHireBoxButtonText}
                linkTo={capHireBoxButtonLink?.url}
              />
            </div>
            <div className={style.tech_card}>
              <ul>
                {capHireListOfTechnology?.map(item => {
                  return (
                    <li>
                      <div className={style.tech_card_content}>
                        {item?.capHireListTechnology}
                      </div>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default memo(HireDeveloper)
